import { Component } from '@angular/core';

@Component({
  selector: 'app-hyginestaft-landing',
  templateUrl: './hyginestaft-landing.component.html',
  styleUrls: ['./hyginestaft-landing.component.scss']
})
export class HyginestaftLandingComponent {

}
